module.exports = __webpack_public_path__ + "static/favicon-285852ab8223b27f4d4bbf58d9fb5a9a.ico";